import React, { FC } from "react";
import { ReactComponent as InfoIcon } from "../assets/images/icon-info.svg";
import TT from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

interface InfoComponentProps {
  tooltip: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal
}
const CustomTooltip = withStyles({
  tooltip: {
    fontSize: "0.8rem",
    padding: "0.5rem 1rem",
    backgroundColor: "#2D3A59",
    opacity: "0.85 !important",
    borderRadius: "10px",
  },
})(TT);
const InfoComponent: FC<InfoComponentProps> = ({ tooltip }) => {
  return (
    <div style={{ margin: "0 0.5rem", display:"flex",alignItems:"ceneter" }}>
      <CustomTooltip title={tooltip} interactive>
        <InfoIcon />
      </CustomTooltip>
    </div>
  );
};

export default InfoComponent;
